import { flatten } from 'lodash';
import React from 'react';
import useDisabledScrollForModal from 'src/hooks/useDisabledScrollForModal';
import styled, { css } from 'styled-components';

const StyledModal = styled.div<{ $zIndex?: number; $useAbsoluteBackground?: boolean }>`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    z-index: ${props => (props.$zIndex ? props.$zIndex : 1000)};

    .background {
        background-color: rgba(0, 0, 0, 0.4);

        ${props =>
            props.$useAbsoluteBackground
                ? css`
                      position: absolute;
                      top: 0;
                      left: 0;
                      width: 100%;
                      height: 100%;
                  `
                : css`
                      position: fixed;
                      width: 100vw;
                      height: 100%;
                      z-index: -1;
                  `}
    }

    .container {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        height: 100%;
    }

    .title-header {
        width: 100%;
        height: 70px;
        background: #f0f1f3;

        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px;

        .close-btn {
            cursor: pointer;
            img {
                display: block;
            }
        }

        button {
            background: #f0f1f3;
        }
    }
`;

interface Props {
    zIndex?: number;
    children?: React.ReactNode;
    backgroundClick?: () => void;
    close?: () => void;
    title?: string;
    useAbsoluteBackground?: boolean;
}

function CumaModal({ zIndex, children, backgroundClick, title, close, useAbsoluteBackground }: Props) {
    const titleRef = React.useRef(null);

    const onClick = React.useCallback((e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
        if (backgroundClick) {
            backgroundClick();
        }
    }, []);

    useDisabledScrollForModal();

    return (
        <StyledModal $zIndex={zIndex} $useAbsoluteBackground={useAbsoluteBackground}>
            <div className="background" onClick={e => onClick(e)} />
            <div className="container">
                {title && (
                    <div className="title-header" ref={titleRef}>
                        <span className="fw-700 ft-18">{title}</span>
                        <div className="close-btn" onClick={close}>
                            <img src="/ic_close_red.svg" alt="닫기버튼" width={16} height={16} />
                        </div>
                    </div>
                )}
                {children}
            </div>
        </StyledModal>
    );
}

export default CumaModal;
